var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.dialogTitle,
        visible: _vm.visible,
        "close-on-click-modal": true,
        "append-to-body": true,
        "show-close": false,
        "custom-class": "all-notes__dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "all-notes" },
        [
          _c("div", { staticClass: "all-notes__title" }, [_vm._v("My notes")]),
          _vm._v(" "),
          _vm._l(_vm.filteredList, function (note, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "all-notes__item",
                class: { fixed: note.fixed },
              },
              [
                _c("Note", {
                  attrs: {
                    date: note.created,
                    text: note.body__value,
                    fixed: note.fixed,
                    "note-id": note.id,
                  },
                  on: {
                    startEvent: function ($event) {
                      _vm.loading = true
                    },
                    finishEvent: function ($event) {
                      _vm.loading = false
                    },
                  },
                }),
              ],
              1
            )
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }